import config from "../../config";
import { SERVICE_CLUB_PACKAGE_FEES } from "../components/brand/equipment-configurator/constants";

export const isPlatinumServiceClubAddon = (equipment) =>
  Number(equipment?.terminal?.id ?? equipment?.id) ===
  config.paymentcloud.PLATINUM_SERVICE_CLUB_EQUIPMENT_ID;

export function getServiceClubFee(equipment) {
  if (!isPlatinumServiceClubAddon(equipment)) return null;
  const pkg = equipment?.package_key || equipment?.package;
  return SERVICE_CLUB_PACKAGE_FEES[pkg] ?? null;
}
